import { PaymentMode } from 'fitbeat.models';
import React from 'react';
import {
  ActivityIndicator,
  Image,
  StyleSheet,
  Text,
} from 'react-native';
import PoweredStripe from '../../assets/images/powered-by-stripe-light.png';
import { Button } from '../../components';
import Theme from '../../theme';

export const PaymentMethodButtons = ({
  t,
  isLoading,
  onPress,
  showTitle,
  hasAccessToAStudioGym,
}) => {
  if (isLoading) {
    return (
      <ActivityIndicator
        size='small'
        color={Theme.PRIMARY}
        animating={isLoading}
      />
    );
  }

  const translationContext = { context: showTitle ? '' : 'join' };
  return (
    <>
      {showTitle &&
        <Text style={styles.selectPaymentMethodTitle}>{t('selectPaymentMethod')}</Text>
      }
      <Button
        isLoading={isLoading}
        fontColor={Theme.WHITE}
        title={t('proceedPayment', translationContext)}
        containerStyle={styles.paymentButton}
        onPress={() => onPress(PaymentMode.CreditCardSetup)}
      />
      {hasAccessToAStudioGym &&
        <Button
          isLoading={isLoading}
          fontColor={Theme.WHITE}
          title={t('proceedDirectDebit', translationContext)}
          containerStyle={styles.paymentButton}
          onPress={() => onPress(PaymentMode.DebitOrderSetup)}
        />
      }
      <Button
        isLoading={isLoading}
        fontColor={Theme.WHITE}
        title={t('proceedApplGooglePay', translationContext)}
        containerStyle={styles.paymentButton}
        onPress={() => onPress(PaymentMode.DigitalWalletSetup)}
      />

      <Image
        source={PoweredStripe}
        style={styles.stripe}
      />
    </>
  );
};

const styles = StyleSheet.create({
  selectPaymentMethodTitle: {
    fontSize: 18,
    color: Theme.CHARCOAL,
    fontFamily: Theme.Custom700,
  },
  paymentButton: {
    marginTop: 10,
  },
  stripe: {
    height: 17,
    width: 78,
    marginTop: 15,
    marginBottom: 5,
    alignSelf: 'center',
  },
});
